import { useTranslation } from '@/i18n/useTranslation'

/** Practice / sandbox OMS used for exploration without touching production data. */
export const UAT_LOGIN_URL = 'https://oms-uat.shopquay.com/auth/staff/login'

/** Show tip only when the user is not already on UAT (or local). */
export function shouldShowUatSignupTip(hostname = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  const host = String(hostname || '').toLowerCase()
  if (!host || host === 'localhost' || host === '127.0.0.1') return false
  if (host.includes('oms-uat') || host.startsWith('uat.')) return false
  return true
}

type Props = {
  className?: string
  /** `onDark` for SignupLayout chrome; `onLight` for white cards / dashboard. */
  variant?: 'onDark' | 'onLight'
}

/**
 * PROD notice: a UAT practice shop is provisioned automatically after shop create.
 */
export function SignupUatSandboxTip({ className = '', variant = 'onDark' }: Props) {
  const { t } = useTranslation('common')
  if (!shouldShowUatSignupTip()) return null

  const box =
    variant === 'onLight'
      ? 'rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-950'
      : 'rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-white/85'

  const linkClass =
    variant === 'onLight'
      ? 'font-semibold text-sky-800 underline hover:text-sky-950'
      : 'font-semibold text-teal-200 underline hover:text-white'

  return (
    <aside className={`${box} ${className}`.trim()} role="note">
      <p className="font-medium">{t('marketing.signup.uatTip.title')}</p>
      <p className="mt-1 leading-relaxed">
        {t('marketing.signup.uatTip.body')}{' '}
        <a href={UAT_LOGIN_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
          {t('marketing.signup.uatTip.linkLabel')}
        </a>
        {t('marketing.signup.uatTip.bodyAfter')}
      </p>
    </aside>
  )
}

export default SignupUatSandboxTip
